import React from 'react';
import placeholder from 'assets/img/image-placeholder.png';
import classes from './about-us-block.scss';
export const AboutUs = ({
  headingText,
  bodyText,
  imgUrl
}) => {
  const isInIFrame = window.self !== window.top;
  const shouldShowImagePlaceholder = isInIFrame && !imgUrl;
  const shouldShowTextPlaceholder = isInIFrame && !bodyText;
  const shouldHideImage = !isInIFrame && !imgUrl;
  const shouldHideBlock = !isInIFrame && !headingText && !bodyText && !imgUrl;
  if (shouldHideBlock) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, headingText || 'About us'), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, shouldShowTextPlaceholder ? 'Write some body copy here...' : bodyText)), /*#__PURE__*/React.createElement("div", {
    className: classes.image
  }, /*#__PURE__*/React.createElement("img", {
    src: shouldShowImagePlaceholder ? placeholder : imgUrl,
    className: shouldHideImage ? classes.hideImage : ''
  }))));
};